import { TicketFareStateEnum, PublicTicketFareStateController } from '@/api';

export default {
  getTicketFareStateList: async (): Promise<TicketFareStateEnum[]> => {
    const response = await PublicTicketFareStateController.getAll();
    return response.data?.data ?? [];
  },
};
